import { ApiClient } from '@/lib/apiClient';
import type { ExtendedParameters, ListResponse } from '@/types/api';
import type { CreateSiteProduct, SiteProduct } from '@/types/siteProduct';

export default class SiteProductService extends ApiClient<SiteProduct, CreateSiteProduct> {

  constructor() {
    super('/v1/siteproduct', 'id');
  }

  getFilteredListView({ filter, signal, method, }: ExtendedParameters): Promise<ListResponse<SiteProduct>> {
    return super.getFilteredList({ filter, signal, method, pathOverride: '/extended-view' });
  }

  getFilteredList({ filter, signal, method, }: ExtendedParameters): Promise<ListResponse<SiteProduct>> {
    return super.getFilteredList({ filter, signal, method, pathOverride: '/extended' });
  }
}
